import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { JoinSelf, GameController, BigButton, Label } from "@/components/game/mobile";

export default function PlayerGame() {
  const [params] = useSearchParams();
  const urlCode = (params.get("code") || "").toUpperCase();
  const remote = params.get("remote") === "1";
  const [code, setCode] = useState(urlCode);
  const [typed, setTyped] = useState(urlCode);
  const [session, setSession] = useState(null);

  useEffect(() => {
    if (!code) return;
    const saved = localStorage.getItem(`tp_player_${code}`);
    if (saved) setSession(JSON.parse(saved));
  }, [code]);

  const join = (s) => {
    localStorage.setItem(`tp_player_${code}`, JSON.stringify(s));
    setSession(s);
  };
  const leave = () => { localStorage.removeItem(`tp_player_${code}`); setSession(null); };

  if (!code) {
    return (
      <div className="neon-bg min-h-screen flex flex-col px-6 py-8 relative">
        <div className="relative z-10 flex-1 flex flex-col max-w-md w-full mx-auto">
          <div className="text-center mb-8 mt-4">
            <h1 className="font-display font-black text-4xl uppercase tracking-tight">
              <span className="text-white text-glow-magenta">Gimme a</span><span className="text-[#00F0FF]">sQuizz</span>
            </h1>
          </div>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="glass rounded-3xl p-6 border border-white/10">
            <Label>Game Code</Label>
            <input data-testid="mobile-room-code-input" value={typed} onChange={(e) => setTyped(e.target.value.toUpperCase().slice(0, 4))} placeholder="ABCD" autoFocus
              className="w-full text-center font-display font-black text-5xl tracking-[0.3em] bg-white/5 border-2 border-white/20 rounded-2xl py-6 text-white focus:border-[#00F0FF] outline-none uppercase" />
            <BigButton testid="mobile-code-continue" disabled={typed.length < 4} onClick={() => setCode(typed)}>Continue <ArrowRight className="w-6 h-6" /></BigButton>
          </motion.div>
        </div>
      </div>
    );
  }

  if (!session) {
    return (
      <div className="neon-bg min-h-screen flex flex-col relative">
        <div className="relative z-10 flex flex-col min-h-screen">
          <div className="text-center mt-6 mb-2">
            <h1 className="font-display font-black text-3xl uppercase tracking-tight">
              <span className="text-white text-glow-magenta">Gimme a</span><span className="text-[#00F0FF]">sQuizz</span>
            </h1>
            <p className="text-white/50 font-head text-sm mt-1">Game {code}{remote && " · Remote player 🌐"}</p>
            </div>
          <JoinSelf code={code} onJoined={join} />
        </div>
      </div>
    );
  }

  return <GameController code={code} session={session} isHost={false} remote={remote} onLeave={leave} />;
}
